module.exports = "<div>\n    <rzslider\n        rz-slider-model=\"slider.value\"\n        rz-slider-options=\"slider.options\"\n    ></rzslider>\n</div>";